
export const pathPrefix = () => {
    return process.env.REACT_APP_IS_INSIDE_WEBAPP === "true" ? '/ingresso/cliente' : ''
}
